<template>
  <v-container fluid class="pa-0 ma-0">
    <!-- Botão Voltar -->
    <div class="back-action d-flex mb-4">
      <v-btn color="#1d4ed8" dark elevation="1" small @click="voltar">
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar
      </v-btn>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation :disabled="modoVisualizacao">
      <!-- Stepper Horizontal -->
      <v-card class="mb-4" elevation="3">
        <v-stepper v-model="currentStep" class="elevation-0">
          <v-stepper-header class="stepper-header-custom">
            <v-stepper-step :complete="currentStep > 1" step="1" color="#1d4ed8" :editable="currentStep > 1">
              <span class="step-label">Vínculo</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2" color="#1d4ed8" :editable="currentStep > 2">
              <span class="step-label">Dados Pessoais</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 3" step="3" color="#1d4ed8" :editable="currentStep > 3">
              <span class="step-label">CNH</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" color="#1d4ed8">
              <span class="step-label">Status</span>
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>

      <v-stepper-content step="1">
        <!-- GRUPO 1 — Vínculo ao Participante -->
        <v-card class="mb-4 card-section" elevation="3">
          <v-card-title class="section-title py-3">
          <v-icon left color="#1d4ed8" size="22">mdi-briefcase</v-icon>
          <span class="font-weight-bold text-h6" style="color: #1d4ed8;">Vínculo ao Participante</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-subtitle class="text-caption text--secondary pt-3 pb-0">
          Selecione o transportador (participante) ao qual este motorista será vinculado.
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="8">
              <v-autocomplete
                v-model="motorista.idParticipante"
                :items="participantes"
                item-text="nome"
                item-value="id"
                label="Participante Vinculado *"
                :rules="[rules.required]"
                outlined
                dense
                :disabled="modoVisualizacao || modoEdicao"
                :hint="modoEdicao ? 'Para alterar o vinculo, exclua e cadastre novamente' : ''"
                persistent-hint
                no-data-text="Nenhum participante encontrado"
              >
                <template v-slot:prepend-inner>
                  <v-icon small color="grey">mdi-account-tie</v-icon>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="motorista.tipo_contrato"
                :items="tiposContrato"
                item-text="text"
                item-value="value"
                label="Tipo de Contrato *"
                :rules="[rules.required]"
                outlined
                dense
                :disabled="modoVisualizacao"
                clearable
              ></v-select>
            </v-col>
          </v-row>
          <v-alert
            v-if="participantes.length === 0 && !loading"
            type="warning"
            dense text
            class="mt-3 mb-0"
          >
            Você não tem participantes (transportadores) vinculados ao seu usuário.
            Cadastre um transportador antes de cadastrar motoristas.
          </v-alert>
        </v-card-text>
      </v-card>
      </v-stepper-content>

      <v-stepper-content step="2">
        <!-- GRUPO 2 — Dados Pessoais -->
        <v-card class="mb-4 card-section" elevation="3">
          <v-card-title class="section-title py-3">
            <v-icon left color="#1d4ed8" size="22">mdi-account</v-icon>
            <span class="font-weight-bold text-h6" style="color: #1d4ed8;">Dados Pessoais</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle class="text-caption text--secondary pt-3 pb-0">
            Identificação, contato e endereço do motorista.
          </v-card-subtitle>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="motorista.cpf"
                  v-mask="'###.###.###-##'"
                  label="CPF *"
                  placeholder="000.000.000-00"
                  :rules="[rules.required, rules.cpf]"
                  outlined dense hide-details="auto" class="mb-2"
                  :disabled="modoVisualizacao"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-card-account-details-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-text-field
                  v-model="motorista.nome"
                  label="Nome *"
                  placeholder="Nome completo do motorista"
                  :rules="[rules.required]"
                  outlined dense hide-details="auto" class="mb-2"
                  :disabled="modoVisualizacao"
                  maxlength="100"
                  @input="motorista.nome = ($event || '').toUpperCase()"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-account-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="motorista.rg"
                  label="RG *"
                  placeholder="00.000.000-0"
                  :rules="[rules.required]"
                  outlined dense hide-details="auto" class="mb-2"
                  :disabled="modoVisualizacao"
                  maxlength="20"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-card-account-details</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="motorista.rg_orgao_expedidor"
                  label="Órgão Expedidor *"
                  placeholder="Ex: SSP"
                  :rules="[rules.required]"
                  outlined dense hide-details="auto" class="mb-2"
                  :disabled="modoVisualizacao"
                  maxlength="20"
                  @input="motorista.rg_orgao_expedidor = ($event || '').toUpperCase()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  v-model="motorista.sexo"
                  :items="opcoesSexo"
                  item-text="text"
                  item-value="value"
                  label="Sexo *"
                  :rules="[rules.required]"
                  outlined dense clearable
                  :disabled="modoVisualizacao"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="motorista.email"
                  label="E-mail"
                  type="email"
                  placeholder="motorista@exemplo.com"
                  outlined dense hide-details="auto" class="mb-2"
                  :disabled="modoVisualizacao"
                  maxlength="120"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-email-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="motorista.telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  label="Celular"
                  placeholder="(99) 99999-9999"
                  outlined dense hide-details="auto" class="mb-2"
                  :disabled="modoVisualizacao"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-cellphone</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <!-- ENDERECO -->
              <v-col cols="12">
                <v-divider class="my-2"></v-divider>
                <div class="text-subtitle-2 font-weight-bold mb-2" style="color: #1d4ed8;">
                  <v-icon small color="#1d4ed8" class="mr-1">mdi-map-marker</v-icon>
                  Endereço
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-model="motorista.cep"
                  v-mask="'#####-###'"
                  label="CEP *"
                  :rules="[rules.required]"
                  placeholder="00000-000"
                  outlined dense
                  hint="Sera salvo sem o traco"
                  persistent-hint
                  :disabled="modoVisualizacao"
                  @blur="buscarCep"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="motorista.endereco"
                  label="Logradouro *"
                  :rules="[rules.required]"
                  placeholder="Rua, avenida..."
                  outlined dense
                  :disabled="modoVisualizacao"
                  maxlength="200"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-model="motorista.numero"
                  label="Número"
                  type="text"
                  outlined dense
                  hint="Letras serao removidas ao salvar. 'SN' = sem numero"
                  persistent-hint
                  maxlength="10"
                  :disabled="modoVisualizacao"
                  @input="motorista.numero = (motorista.numero || '').toUpperCase()"
                  @blur="motorista.numero = normalizarNumeroEndereco(motorista.numero)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-model="motorista.complemento"
                  label="Complemento"
                  outlined dense
                  :disabled="modoVisualizacao"
                  maxlength="100"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="motorista.bairro"
                  label="Bairro *"
                  :rules="[rules.required]"
                  outlined dense
                  :disabled="modoVisualizacao"
                  maxlength="100"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="motorista.ibge_estado"
                  :items="estados"
                  item-text="sigla"
                  item-value="id"
                  label="UF *"
                  outlined dense
                  :loading="loadingEstados"
                  :disabled="modoVisualizacao || loadingEstados"
                  :rules="[rules.required]"
                  @change="onUfChange"
                  no-data-text="Carregando estados..."
                  hint="Sigla do estado"
                  persistent-hint
                >
                  <template v-slot:item="{ item }">
                    <span class="font-weight-medium mr-2">{{ item.sigla }}</span>
                    <span class="text--secondary">{{ item.nome }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <v-autocomplete
                  v-model="motorista.ibge_cidade"
                  :items="cidades"
                  item-text="nome"
                  item-value="id"
                  label="Cidade *"
                  outlined dense
                  :loading="loadingCidades"
                  :disabled="modoVisualizacao || loadingCidades || !motorista.ibge_estado"
                  :rules="[rules.required]"
                  :no-data-text="!motorista.ibge_estado ? 'Selecione a UF primeiro' : (loadingCidades ? 'Carregando cidades...' : 'Nenhuma cidade')"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="3">
        <!-- GRUPO 3 — CNH -->
        <v-card class="mb-4 card-section" elevation="3">
          <v-card-title class="section-title py-3">
            <v-icon left color="#1d4ed8" size="22">mdi-id-badge</v-icon>
            <span class="font-weight-bold text-h6" style="color: #1d4ed8;">Carteira Nacional de Habilitação</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle class="text-caption text--secondary pt-3 pb-0">
            Dados da CNH do motorista.
          </v-card-subtitle>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="motorista.numero_cnh"
                  label="Nº CNH *"
                  placeholder="Somente números"
                  :rules="[rules.required]"
                  outlined dense
                  :disabled="modoVisualizacao"
                  maxlength="20"
                  @input="motorista.numero_cnh = ($event || '').replace(/\D/g, '').substring(0, 20)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-card-account-details</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="motorista.categoria_cnh"
                  :items="categoriasCnh"
                  label="Categoria *"
                  :rules="[rules.required]"
                  outlined dense
                  :disabled="modoVisualizacao"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="motorista.validade_cnh"
                  label="Validade *"
                  type="date"
                  :rules="[rules.required]"
                  outlined dense
                  :disabled="modoVisualizacao"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="4">
        <!-- GRUPO 4 — Status -->
        <v-card class="mb-4 card-section" elevation="3">
          <v-card-title class="section-title py-3">
            <v-icon left color="#1d4ed8" size="22">mdi-clipboard-list</v-icon>
            <span class="font-weight-bold text-h6" style="color: #1d4ed8;">Status</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle class="text-caption text--secondary pt-3 pb-0">
            Situação atual do motorista no cadastro.
          </v-card-subtitle>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" md="6">
                <div class="status-panel d-flex align-center">
                  <div>
                    <v-checkbox
                      v-model="motorista.ativo"
                      label="Motorista ativo"
                      color="#1d4ed8"
                      hide-details
                      dense
                      class="mt-0"
                      :disabled="modoVisualizacao"
                    ></v-checkbox>
                    <div class="text-caption text--secondary mt-1">
                      <v-icon small :color="motorista.ativo ? 'success' : 'grey'">mdi-circle</v-icon>
                      {{ motorista.ativo ? 'Disponível para operações' : 'Inativo no sistema' }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-stepper-content>

          </v-stepper-items>
        </v-stepper>
      </v-card>

      <!-- Botões de Ação -->
      <v-card class="mb-4" elevation="0">
        <v-card-actions class="justify-space-between pa-4">
          <div>
            <!-- Voltar/Proximo aparecem tambem em modo visualizacao para
                 permitir o usuario navegar e ver todas as etapas do cadastro -->
            <v-btn
              text
              color="grey darken-1"
              @click="previousStep"
              :disabled="currentStep === 1"
            >
              <v-icon left small>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
            <v-btn
              text
              color="grey darken-1"
              @click="nextStep"
              :disabled="currentStep === steps.length"
            >
              Próximo
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
          <div>
            <v-btn
              text
              color="grey darken-1"
              @click="limparFormulario"
              v-if="!modoVisualizacao"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Limpar
            </v-btn>
            <!-- Botao Salvar APENAS na ultima aba (Status) -->
            <v-btn
              v-if="modoVisualizacao || currentStep === steps.length"
              color="#1d4ed8"
              dark
              elevation="2"
              :loading="loading"
              @click="modoVisualizacao ? habilitarEdicao() : salvarMotorista()"
              class="px-6"
            >
              <v-icon left small>{{ modoVisualizacao ? 'mdi-pencil' : 'mdi-content-save' }}</v-icon>
              {{ modoVisualizacao ? 'Editar' : (modoEdicao ? 'Atualizar' : 'Salvar') }} Motorista
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>

    <!-- SNACKBAR -->
    <v-snackbar 
      v-model="snackbar" 
      :color="snackbarColor" 
      timeout="4000" 
      top 
      right
      elevation="6"
    >
      <div class="d-flex align-center">
        <v-icon v-if="snackbarColor === 'success'" class="mr-2">mdi-check-circle</v-icon>
        <v-icon v-else class="mr-2">mdi-alert-circle</v-icon>
        {{ snackbarText }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import axios from 'axios'
import Transportador from '../service/transportador'
// Helper de auditoria - alimenta colunas codigo/nome/data_criacao+alteracao
// adicionadas pela migration_auditoria_veiculo_motorista_ciot.sql.
import { auditoriaPayload } from '../utils/auditoria'

export default {
  name: 'CadastroMotorista',
  directives: { mask },
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      currentStep: 1,
      // Vinculo participante-motorista (PK do registro de associacao)
      vinculoId: 0,
      participantes: [],
      // IBGE: 27 estados (carregados 1x no mounted) e municipios por UF (sob demanda)
      estados: [],
      cidades: [],
      loadingEstados: false,
      loadingCidades: false,
      steps: [
        { icon: 'mdi-briefcase', label: 'Vínculo' },
        { icon: 'mdi-account', label: 'Dados Pessoais' },
        { icon: 'mdi-id-badge', label: 'CNH' },
        { icon: 'mdi-clipboard-list', label: 'Status' }
      ],

      motorista: {
        // Todos os campos abaixo SAO persistidos no backend
        // (entity Motorista + DTO ParticipanteMotoristaRequisicao)
        idParticipante: null,
        idMotorista: 0,
        cpf: '',
        nome: '',
        ativo: true,
        rg: '',
        rg_orgao_expedidor: '',
        sexo: '',
        email: '',
        telefone: '',          // mapeado para 'celular' no payload
        tipo_contrato: null,
        numero_cnh: '',        // mapeado para 'cnh' no payload
        categoria_cnh: '',
        validade_cnh: '',
        cep: '',
        endereco: '',
        complemento: '',
        numero: '',
        bairro: '',
        ibge_cidade: null,
        ibge_estado: null,
        bacen_pais: 1058
      },

      // tipo_contrato persistido no backend (motorista.tipo_contrato)
      tiposContrato: [
        { text: 'Frota', value: 1 },
        { text: 'Cooperado', value: 2 },
        { text: 'Agregado', value: 3 },
        { text: 'Terceiro', value: 4 }
      ],

      opcoesSexo: [
        { text: 'Masculino', value: 'M' },
        { text: 'Feminino', value: 'F' }
      ],

      categoriasCnh: ['A', 'B', 'C', 'D', 'E', 'AB', 'AC', 'AD', 'AE'],
      
      rules: {
        required: v => !!v || 'Campo obrigatório',
        cpf: v => {
          if (!v) return true
          const cpf = v.replace(/\D/g, '')
          if (cpf.length !== 11) return 'CPF inválido'
          
          // Validação básica de CPF
          let sum = 0
          let rest
          
          if (cpf === '00000000000') return 'CPF inválido'
          
          for (let i = 1; i <= 9; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
          }
          rest = (sum * 10) % 11
          
          if ((rest === 10) || (rest === 11)) rest = 0
          if (rest !== parseInt(cpf.substring(9, 10))) return 'CPF inválido'
          
          sum = 0
          for (let i = 1; i <= 10; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
          }
          rest = (sum * 10) % 11
          
          if ((rest === 10) || (rest === 11)) rest = 0
          if (rest !== parseInt(cpf.substring(10, 11))) return 'CPF inválido'
          
          return true
        }
      }
    }
  },
  
  computed: {
    modoEdicao() {
      return !!this.$route.params.id && this.$route.params.id !== 'novo'
    },
    modoVisualizacao() {
      return this.$route.name === 'VisualizarMotorista'
    },
    motoristaId() {
      return this.$route.params.id
    }
  },
  
  async mounted() {
    const t0 = performance.now()
    // OTIMIZACAO: paraleliza as 3 chamadas iniciais. Antes era serial:
    //   1) Promise.all([participantes, estados])
    //   2) getParticipanteMotoristaById (esperava as 2 acima)
    // Agora as 3 disparam juntas. getParticipanteMotoristaById nao
    // depende das outras duas (nao usa participantes nem estados
    // pra montar a request), entao pode rodar em paralelo.
    const calls = [
      this.carregarParticipantes(),
      this.carregarEstados()
    ]
    if (this.modoEdicao || this.modoVisualizacao) {
      calls.push(this._fetchMotoristaData())
    }
    const resultados = await Promise.all(calls)
    const dadosMotorista = resultados[2] // pode ser undefined se nao for edit/view

    if (dadosMotorista) {
      await this._aplicarDadosMotorista(dadosMotorista)
    }
    console.log(`[CadastroMotorista] mounted total: ${(performance.now() - t0).toFixed(0)}ms`)
  },

  methods: {
    voltar() {
      this.$router.push({ name: 'ListaMotoristas' })
    },

    habilitarEdicao() {
      this.$router.push({ name: 'EditarMotorista', params: { id: this.motoristaId } })
    },

    async carregarParticipantes() {
      try {
        const userId = localStorage.getItem('id')
        if (!userId || userId === 'null') return
        const resp = await Transportador.getTransportadoresUsuario(userId)
        this.participantes = (resp.data || []).map(p => ({
          id: p.id,
          nome: (p.nomeFantasia || p.razaoSocial || p.nome || '') +
                (p.cnpj ? ' (' + p.cnpj + ')' : '')
        }))
      } catch (e) {
        console.warn('Erro ao carregar participantes:', e)
        this.participantes = []
      }
    },

    // Cache de dados do IBGE no localStorage. Estados e municipios sao
    // praticamente estaticos, entao nao faz sentido rebuscar na API externa
    // (lenta e sujeita a rate limit) a cada abertura do formulario. Versao no
    // prefixo permite invalidar o cache no futuro so trocando o numero.
    _lerCacheIbge(key) {
      try {
        const raw = localStorage.getItem(key)
        if (!raw) return null
        const arr = JSON.parse(raw)
        return Array.isArray(arr) && arr.length ? arr : null
      } catch (e) {
        return null
      }
    },

    _gravarCacheIbge(key, valor) {
      try {
        localStorage.setItem(key, JSON.stringify(valor))
      } catch (e) {
        // localStorage cheio/indisponivel - segue sem cache
      }
    },

    async carregarEstados() {
      const CACHE_KEY = 'ibge:v1:estados'
      const cache = this._lerCacheIbge(CACHE_KEY)
      if (cache) {
        // Cache hit: usa imediatamente, sem rede.
        this.estados = cache
        return
      }
      this.loadingEstados = true
      try {
        const resp = await axios.get(
          'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
        )
        // Retorno IBGE: [{id, sigla, nome}, ...]
        this.estados = (resp.data || []).map(e => ({
          id: e.id, sigla: e.sigla, nome: e.nome
        }))
        this._gravarCacheIbge(CACHE_KEY, this.estados)
      } catch (e) {
        console.warn('Erro ao carregar estados IBGE:', e)
        this.estados = []
      } finally {
        this.loadingEstados = false
      }
    },

    async carregarCidades(idEstado) {
      if (!idEstado) {
        this.cidades = []
        return
      }
      const CACHE_KEY = `ibge:v1:cidades:${idEstado}`
      const cache = this._lerCacheIbge(CACHE_KEY)
      if (cache) {
        // Cache hit: a lista (que pode ter centenas de itens) ja vem pronta.
        this.cidades = cache
        return
      }
      this.loadingCidades = true
      try {
        const resp = await axios.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${idEstado}/municipios`
        )
        // Retorno IBGE: [{id, nome, ...}, ...]
        this.cidades = (resp.data || []).map(c => ({
          id: c.id, nome: c.nome
        }))
        this._gravarCacheIbge(CACHE_KEY, this.cidades)
      } catch (e) {
        console.warn('Erro ao carregar cidades IBGE:', e)
        this.cidades = []
      } finally {
        this.loadingCidades = false
      }
    },

    onUfChange(novoIdEstado) {
      // Quando o usuario muda a UF, limpa a cidade e recarrega a lista
      this.motorista.ibge_cidade = null
      this.carregarCidades(novoIdEstado)
    },
    
    nextStep() {
      if (this.currentStep < this.steps.length) {
        this.currentStep += 1
      }
    },

    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep -= 1
      }
    },
    
    // Fetch puro do motorista (sem aplicar no form). Usado pelo mounted
    // para paralelizar com carregarParticipantes/carregarEstados.
    // Normaliza o campo Numero do endereco para coerencia entre o que o
    // usuario digita e o que vai pro banco (coluna INTEGER):
    //   - vazio  -> ''         (vai como 0 no banco)
    //   - 'SN' / 'S/N' -> 'SN' (vai como 0 no banco, sentinel de Sem Numero)
    //   - '12B' -> '12'        (extrai digitos)
    //   - 'AB'  -> ''          (sem digitos, fica vazio)
    //   - '00123' -> '123'     (remove zeros a esquerda)
    normalizarNumeroEndereco(valor) {
      const raw = String(valor || '').trim().toUpperCase()
      if (!raw) return ''
      if (raw === 'SN' || raw === 'S/N') return 'SN'
      const digitos = raw.replace(/\D/g, '').replace(/^0+/, '')
      return digitos
    },

    async _fetchMotoristaData() {
      const t0 = performance.now()
      try {
        const resp = await Transportador.getParticipanteMotoristaById(this.motoristaId)
        console.log(`[CadastroMotorista] fetch motorista: ${(performance.now() - t0).toFixed(0)}ms`)
        if (!resp || !resp.data) return null
        return resp.data
      } catch (error) {
        console.error('Erro ao carregar motorista:', error)
        if (error && error.response && error.response.status === 404) {
          this.showSnackbar('Motorista nao encontrado', 'error')
        } else {
          this.showSnackbar('Erro ao carregar dados do motorista', 'error')
        }
        this.voltar()
        return null
      }
    },

    // Aplica os dados ja carregados no form. Roda APOS as listas
    // (participantes + estados) terem chegado, garantindo que os
    // v-autocomplete consigam resolver os v-models.
    async _aplicarDadosMotorista(v) {
      this.loading = true
      try {
        const m = v.motorista || {}
        const idPart = v.participante ? v.participante.id : null
        this.vinculoId = v.id
        const ibgeEstado = m.ibgeEstado != null ? m.ibgeEstado : null
        const ibgeCidade = m.ibgeCidade != null ? m.ibgeCidade : null

        this.motorista = {
          ...this.motorista,
          idParticipante: idPart,
          idMotorista: m.id || 0,
          cpf: m.cpf || '',
          nome: m.nome || '',
          ativo: m.ativo !== false,
          // Campos CIOT
          rg: m.rg || '',
          rg_orgao_expedidor: m.rgOrgaoExpedidor || '',
          sexo: m.sexo || '',
          email: m.email || '',
          telefone: m.celular || '',
          tipo_contrato: m.tipoContrato != null ? m.tipoContrato : null,
          numero_cnh: m.cnh || '',
          categoria_cnh: m.cnhCategoria || '',
          validade_cnh: m.validadeCnh || '',
          cep: m.cep || '',
          endereco: m.endereco || '',
          complemento: m.complemento || '',
          // Numero: 0 no banco = 'SN' na UI (sentinel de Sem Numero)
          numero: (m.numero === 0 || m.numero === '0') ? 'SN' : (m.numero != null ? String(m.numero) : ''),
          bairro: m.bairro || '',
          ibge_cidade: null, // setado abaixo APOS carregar a lista
          ibge_estado: ibgeEstado,
          bacen_pais: m.bacenPais != null ? m.bacenPais : 1058
        }

        // Se tem UF gravada, carrega as cidades e seleciona a do banco
        if (ibgeEstado) {
          const tCid = performance.now()
          await this.carregarCidades(ibgeEstado)
          console.log(`[CadastroMotorista] carregar cidades IBGE: ${(performance.now() - tCid).toFixed(0)}ms`)
          this.motorista.ibge_cidade = ibgeCidade
        }

        // Defesa: se o participante do motorista nao esta na lista do usuario
        // (ex.: vinculo foi removido depois que o motorista foi cadastrado),
        // injeta um placeholder pra o v-autocomplete exibir algo coerente em
        // vez de blank. Mesclado do PR #83 ao paralelizar (PR #85).
        if (idPart && !this.participantes.find(p => p.id === idPart)) {
          this.participantes = [...this.participantes, {
            id: idPart,
            nome: `Participante #${idPart} (sem acesso ao vinculo)`
          }]
        }
      } finally {
        this.loading = false
      }
    },

    // Mantida pra compat (caso seja chamada de outro lugar). Faz fetch + apply.
    async carregarMotorista() {
      const dados = await this._fetchMotoristaData()
      if (dados) await this._aplicarDadosMotorista(dados)
    },
    async buscarCep() {
      const cep = (this.motorista.cep || '').replace(/\D/g, '')
      if (cep && cep.length === 8) {
        try {
          const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
          if (response.data && !response.data.erro) {
            this.motorista.endereco = response.data.logradouro || ''
            this.motorista.bairro = response.data.bairro || ''
            // Codigo IBGE do municipio vem direto do ViaCEP (campo "ibge")
            if (response.data.ibge) {
              const ibgeCidade = parseInt(response.data.ibge, 10)
              const ibgeEstado = parseInt(String(response.data.ibge).substring(0, 2), 10)
              this.motorista.ibge_estado = ibgeEstado
              // Carrega a lista de cidades da UF para que o select da Cidade
              // tenha a opcao correta disponivel para seleciona-la.
              await this.carregarCidades(ibgeEstado)
              this.motorista.ibge_cidade = ibgeCidade
            }
          }
        } catch (error) {
          console.error('Erro ao buscar CEP:', error)
        }
      }
    },
    
    async salvarMotorista() {
      if (!this.$refs.form.validate()) {
        this.showSnackbar('Preencha todos os campos obrigatorios', 'error')
        return
      }
      if (!this.motorista.idParticipante) {
        this.showSnackbar('Selecione o Participante Vinculado', 'error')
        this.currentStep = 1
        return
      }
      const cpfLimpo = (this.motorista.cpf || '').replace(/\D/g, '')
      if (cpfLimpo.length !== 11) {
        this.showSnackbar('CPF invalido', 'error')
        this.currentStep = 2
        return
      }

      this.loading = true
      try {
        // Payload FLAT alinhado ao ParticipanteMotoristaRequisicao do backend
        // (wi-cadastro-api). Inclui todos os campos CIOT (opcionais no backend).
        const m = this.motorista
        const payload = {
          // Obrigatorios
          nome: (m.nome || '').trim(),
          cpf: cpfLimpo,
          idMotorista: m.idMotorista || 0,
          idParticipante: m.idParticipante,
          ativo: m.ativo !== false,
          // Opcionais CIOT (enviar null quando vazio para limpar no update)
          rg: m.rg || null,
          rgOrgaoExpedidor: m.rg_orgao_expedidor || null,
          sexo: m.sexo || null,
          email: m.email || null,
          celular: (m.telefone || m.celular) ? (m.telefone || m.celular).replace(/\D/g, '') : null,
          tipoContrato: m.tipo_contrato || null,
          cnh: m.numero_cnh ? String(m.numero_cnh).replace(/\D/g, '') : null,
          cnhCategoria: m.categoria_cnh || null,
          validadeCnh: m.validade_cnh || null,
          cep: m.cep ? m.cep.replace(/\D/g, '') : null,
          endereco: m.endereco || null,
          complemento: m.complemento || null,
          // Numero: aceita texto ('SN', '123', '12B'). Vazio ou 'SN' = 0
          // (sentinel de Sem Numero, ja que o campo no banco eh INTEGER).
          // Caso usuario digite alfanumerico, extrai so digitos. Sem digitos = 0.
          numero: (() => {
            const raw = String(m.numero || '').trim().toUpperCase()
            if (!raw || raw === 'SN' || raw === 'S/N') return 0
            const digitos = raw.replace(/\D/g, '')
            return digitos ? parseInt(digitos, 10) : 0
          })(),
          bairro: m.bairro || null,
          ibgeCidade: m.ibge_cidade || null,
          ibgeEstado: m.ibge_estado || null,
          bacenPais: m.bacen_pais || 1058
        }

        //
        // Mescla auditoria no payload (id+nome do usuario + timestamp).
        // Backend trata os campos como nullable.
        //
        Object.assign(payload, auditoriaPayload(this.modoEdicao))

        if (this.modoEdicao) {
          await Transportador.updateMotorista(this.vinculoId, payload)
          this.showSnackbar('Motorista atualizado com sucesso!', 'success')
        } else {
          await Transportador.insertMotorista(payload)
          this.showSnackbar('Motorista cadastrado com sucesso!', 'success')
        }

        setTimeout(() => this.voltar(), 1200)
      } catch (error) {
        console.error('Erro ao salvar motorista:', error)
        const msg = (error && error.response && error.response.data)
          ? (error.response.data.mensagem || error.response.data.detalhe || 'Erro ao salvar motorista')
          : (error.message || 'Erro ao salvar motorista')
        this.showSnackbar(msg, 'error')
      } finally {
        this.loading = false
      }
    },
    
    limparFormulario() {
      this.$refs.form.reset()
      this.motorista = {
        idParticipante: null,
        idMotorista: 0,
        cpf: '',
        nome: '',
        ativo: true,
        rg: '',
        rg_orgao_expedidor: '',
        sexo: '',
        email: '',
        telefone: '',
        tipo_contrato: null,
        numero_cnh: '',
        categoria_cnh: '',
        validade_cnh: '',
        cep: '',
        endereco: '',
        complemento: '',
        numero: '',
        bairro: '',
        ibge_cidade: null,
        ibge_estado: null,
        bacen_pais: 1058
      }
      this.vinculoId = 0
      this.currentStep = 1
    },
    
    showSnackbar(text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
/* Stepper styles (padrao alinhado ao CIOT) */
.stepper-header-custom {
  box-shadow: none !important;
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 16px;
}

.step-label {
  font-size: 0.85rem;
  font-weight: 500;
}

/* Vuetify v-stepper overrides */
.v-stepper {
  box-shadow: none !important;
  background: transparent !important;
}

.v-stepper__content {
  padding: 16px 24px !important;
}

.action-bar {
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-left: 4px solid #1d4ed8;
  border-radius: 8px !important;
}

.card-section {
  border-radius: 14px !important;
  transition: all 0.3s ease;
  border: none;
  background: linear-gradient(145deg, #f9fbff 0%, #ffffff 60%, #eef2ff 100%);
  box-shadow: 0 14px 36px rgba(29, 78, 216, 0.08);
  overflow: hidden;
  margin-bottom: 10px !important;
  padding: 0 !important;
}

.card-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 40px rgba(29, 78, 216, 0.12) !important;
}

.section-title {
  background: #1d4ed8;
  color: #fff !important;
  border-radius: 10px 10px 0 0;
  padding: 8px 12px !important;
}

.section-title span,
.section-title .v-icon {
  color: #fff !important;
}

.card-section .v-card__title {
  padding: 6px 10px 2px !important;
}

.card-section .v-card__subtitle {
  display: none;
  padding: 0 !important;
  margin: 0 !important;
}

.card-section .v-card__text {
  padding: 4px 8px 2px !important;
}

.card-section .v-row {
  margin-left: -4px;
  margin-right: -4px;
}

.card-section .v-col {
  padding: 2px 6px !important;
}

.card-section .v-messages {
  display: none;
  min-height: 0;
}

.status-panel {
  background: transparent;
  border: none;
  border-radius: 8px !important;
  box-shadow: none;
  padding: 4px 0 0;
}

.v-card {
  border-radius: 14px !important;
}

.rounded-pill {
  border-radius: 999px !important;
}

.gap-2 {
  gap: 8px;
}

/* Efeito nos inputs ao focar */
.v-text-field--outlined:focus-within,
.v-select--outlined:focus-within {
  box-shadow: 0 0 0 2px rgba(29, 78, 216, 0.1);
}

/* Melhorias nos file inputs */
.v-file-input >>> .v-file-input__text {
  font-size: 0.875rem;
}

/* Responsividade */
@media (max-width: 600px) {
  .action-bar .v-card__text {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  
  .action-bar .d-flex.gap-2 {
    width: 100%;
    justify-content: stretch;
  }
  
  .action-bar .v-btn {
    flex: 1;
  }
  
  .card-section {
    border-radius: 10px !important;
  }
  .status-panel {
    border-radius: 10px !important;
  }
}

/* Animação suave nos inputs */
.v-text-field, .v-select, .v-file-input {
  transition: all 0.2s ease;
}

/* Chips de arquivo */
.v-chip.v-size--small {
  max-width: 100%;
}

.v-chip .v-chip__content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.back-action {
  width: 100%;
  justify-content: flex-start !important;
  text-align: left;
  margin-bottom: 8px !important;
  margin-top: 8px !important;
}

/* Switch customizado */
.v-input--switch .v-input--selection-controls__input {
  transform: scale(1.1);
}

/* Textarea com ícone */
.v-textarea >>> .v-input__prepend-inner {
  margin-top: 12px;
}
</style>
